import React from "react";

/**
 * Popup d'information globale (annonce, maintenance, info)
 * type: 'annonce' | 'maintenance' | 'info' | 'finis' (ou autre)
 * title: titre de l'info (optionnel)
 * message: message principal (optionnel)
 * date: date de l'info
 * maintenanceMode: si true, affiche un style d'alerte/maintenance
 */
export default function PopUpInfo({ type, title, message, date, onClose, maintenanceMode }) {
  let icon, color;
  switch (type) {
    case 'maintenance':
      icon = (
        <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
      );
      color = 'bg-red-50 dark:bg-red-900 border-red-200 dark:border-red-700 text-red-900 dark:text-red-100';
      break;
    case 'annonce':
      icon = (
        <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z" /></svg>
      );
      color = 'bg-blue-50 dark:bg-blue-900 border-blue-200 dark:border-blue-700 text-blue-900 dark:text-blue-100';
      break;
    case 'finis':
      icon = (
        <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
      );
      color = 'bg-green-50 dark:bg-green-900 border-green-200 dark:border-green-700 text-green-900 dark:text-green-100';
      break;
    default:
      icon = (
        <svg className="w-5 h-5 text-accent" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z" /></svg>
      );
      color = 'bg-gray-50 dark:bg-gray-900 border-gray-200 dark:border-gray-700 text-gray-900 dark:text-gray-100';
  }

  return (
    <div
      className={`fixed right-6 bottom-6 z-50 shadow-2xl rounded-2xl min-w-[320px] max-w-xs sm:max-w-sm p-6 font-sans border animate-slideIn ${color}`}
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-between mb-2">
        <div className="font-bold text-lg flex items-center gap-2">
          {icon}
          {title || (type === 'maintenance' ? 'Maintenance' : type === 'annonce' ? 'Annonce' : 'Information')}
        </div>
        <button
          onClick={onClose}
          className="ml-2 text-2xl leading-none text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 focus:outline-none"
          aria-label="Fermer"
        >
          &times;
        </button>
      </div>
      {date && (
        <div className="text-xs text-gray-300 dark:text-gray-300 mb-2">
          <span className="font-semibold">Date :</span> {date}
        </div>
      )}
      {message && (
        <div className="mb-2 text-sm">
          {message}
        </div>
      )}
      {maintenanceMode && (
        <div className="mt-2 text-red-700 dark:text-red-200 font-semibold text-sm">
          Le site est actuellement en maintenance. Certaines fonctionnalités peuvent être indisponibles.
        </div>
      )}
    </div>
  );
}
